export interface CollectionItem {
  id: string;
  name: string;
  intro: string;
  count: string;
  cover: string;
  tone: "primary" | "accent" | "secondary";
}

export const collections: CollectionItem[] = [
  {
    id: "c01",
    name: "高分烧脑悬疑合集",
    intro: "反转不断，片单一次看个够",
    count: "42 部",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20a%20detective%20investigation%20board%20with%20maps%20threads%20and%20a%20magnifying%20glass%2C%20dramatic%20moody%20lighting%2C%20deep%20toned%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=640&height=420&seq=jj-col-01&orientation=landscape",
    tone: "primary",
  },
  {
    id: "c02",
    name: "下饭必看轻喜剧",
    intro: "轻松一笑，吃饭更有味",
    count: "58 部",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20a%20bright%20cheerful%20colorful%20playful%20composition%20with%20popcorn%20and%20confetti%2C%20warm%20festive%20lighting%2C%20deep%20toned%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=640&height=420&seq=jj-col-02&orientation=landscape",
    tone: "accent",
  },
  {
    id: "c03",
    name: "国产科幻崛起纪",
    intro: "从零到一的想象力",
    count: "36 部",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20a%20retro%20futuristic%20sci%20fi%20city%20with%20glowing%20structures%20and%20deep%20space%20sky%2C%20dramatic%20moody%20lighting%2C%20deep%20toned%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=640&height=420&seq=jj-col-03&orientation=landscape",
    tone: "secondary",
  },
  {
    id: "c04",
    name: "经典重映 · 黄金年代",
    intro: "值得重看的老电影",
    count: "74 部",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20vintage%20film%20reels%20and%20old%20cinema%20seats%20in%20warm%20sepia%20tones%2C%20nostalgic%20moody%20lighting%2C%20deep%20toned%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=640&height=420&seq=jj-col-04&orientation=landscape",
    tone: "primary",
  },
  {
    id: "c05",
    name: "治愈系日常精选",
    intro: "慢下来，好好生活",
    count: "48 部",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20scene%20of%20a%20soft%20pastel%20countryside%20house%20with%20gentle%20warm%20sunlight%20and%20greenery%2C%20calm%20peaceful%20mood%2C%20deep%20toned%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=640&height=420&seq=jj-col-05&orientation=landscape",
    tone: "secondary",
  },
  {
    id: "c06",
    name: "硬核纪实纪录片",
    intro: "真实，比戏剧更有力",
    count: "63 部",
    cover:
      "https://readdy.ai/api/search-image?query=Stylized%20cinematic%20aerial%20scene%20of%20a%20vast%20natural%20landscape%20with%20mountains%20and%20rivers%20at%20golden%20hour%2C%20epic%20moody%20lighting%2C%20deep%20toned%20background%2C%20film%20aesthetic%2C%20high%20detail%2C%20no%20text&width=640&height=420&seq=jj-col-06&orientation=landscape",
    tone: "accent",
  },
];

export interface TagItem {
  name: string;
  count: string;
  hot?: boolean;
}

export const tagWall: TagItem[] = [
  { name: "悬疑", count: "1286", hot: true },
  { name: "古装", count: "968" },
  { name: "科幻", count: "742" },
  { name: "都市", count: "1104" },
  { name: "甜宠", count: "856" },
  { name: "犯罪", count: "612" },
  { name: "喜剧", count: "1320", hot: true },
  { name: "治愈", count: "588" },
  { name: "国漫", count: "430" },
  { name: "纪录片", count: "496" },
  { name: "高分", count: "720", hot: true },
  { name: "历史", count: "544" },
  { name: "奇幻", count: "668" },
  { name: "青春", count: "812" },
  { name: "动作", count: "946" },
  { name: "一口气看完", count: "1560", hot: true },
  { name: "家庭", count: "474" },
  { name: "职场", count: "398" },
  { name: "冷门佳作", count: "322" },
  { name: "真人秀", count: "612" },
];

export interface RankItem {
  rank: number;
  title: string;
  category: string;
  score: string;
  heat: number;
}

export const dayRank: RankItem[] = [
  { rank: 1, title: "雾都迷踪", category: "悬疑剧集", score: "9.2", heat: 98 },
  { rank: 2, title: "山海秘境", category: "国漫奇幻", score: "9.0", heat: 94 },
  { rank: 3, title: "归途", category: "剧情电影", score: "9.1", heat: 90 },
  { rank: 4, title: "铁血长空", category: "军事动作", score: "8.8", heat: 86 },
  { rank: 5, title: "时光邮局", category: "爱情奇幻", score: "8.9", heat: 82 },
  { rank: 6, title: "春日便当店", category: "治愈美食", score: "8.7", heat: 78 },
  { rank: 7, title: "深海回声", category: "自然纪录", score: "8.6", heat: 71 },
  { rank: 8, title: "青铜时代", category: "历史史诗", score: "8.5", heat: 65 },
];

export const weekRank: RankItem[] = [
  { rank: 1, title: "山海秘境", category: "国漫奇幻", score: "9.0", heat: 97 },
  { rank: 2, title: "风起南城", category: "民国谍战", score: "8.4", heat: 93 },
  { rank: 3, title: "第七号档案", category: "悬疑网剧", score: "8.3", heat: 89 },
  { rank: 4, title: "雾都迷踪", category: "悬疑剧集", score: "9.2", heat: 85 },
  { rank: 5, title: "霓虹晚风", category: "都市甜宠", score: "8.2", heat: 80 },
  { rank: 6, title: "心动信号局", category: "情感综艺", score: "8.0", heat: 74 },
  { rank: 7, title: "归途", category: "剧情电影", score: "9.1", heat: 69 },
  { rank: 8, title: "深海回声", category: "自然纪录", score: "8.6", heat: 62 },
];

export const monthRank: RankItem[] = [
  { rank: 1, title: "归途", category: "剧情电影", score: "9.1", heat: 99 },
  { rank: 2, title: "铁血长空", category: "军事动作", score: "8.8", heat: 95 },
  { rank: 3, title: "春日便当店", category: "治愈美食", score: "8.7", heat: 91 },
  { rank: 4, title: "青铜时代", category: "历史史诗", score: "8.5", heat: 87 },
  { rank: 5, title: "山海秘境", category: "国漫奇幻", score: "9.0", heat: 83 },
  { rank: 6, title: "雾都迷踪", category: "悬疑剧集", score: "9.2", heat: 79 },
  { rank: 7, title: "时光邮局", category: "爱情奇幻", score: "8.9", heat: 72 },
  { rank: 8, title: "深海回声", category: "自然纪录", score: "8.6", heat: 66 },
];

export interface DiscussionItem {
  id: string;
  user: string;
  avatar: string;
  role: string;
  content: string;
  show: string;
  likes: string;
  replies: string;
  time: string;
}

export const discussions: DiscussionItem[] = [
  {
    id: "d1",
    user: "追剧不睡觉",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustrated%20avatar%20portrait%20of%20a%20friendly%20young%20woman%20with%20short%20hair%2C%20clean%20bold%20shapes%2C%20solid%20warm%20pastel%20background%2C%20centered%20head%20and%20shoulders%2C%20modern%20editorial%20illustration%2C%20no%20text&width=160&height=160&seq=jj-ava-01&orientation=squarish",
    role: "剧评达人",
    content: "《雾都迷踪》第12集那个转场真的绝了，前面埋的伏笔全串起来了，编剧是真敢写。建议一口气刷完，弹幕里全是细节党。",
    show: "雾都迷踪",
    likes: "2.4万",
    replies: "386",
    time: "8 分钟前",
  },
  {
    id: "d2",
    user: "便当研究所",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustrated%20avatar%20portrait%20of%20a%20middle%20aged%20man%20wearing%20glasses%2C%20clean%20bold%20shapes%2C%20solid%20warm%20pastel%20background%2C%20centered%20head%20and%20shoulders%2C%20modern%20editorial%20illustration%2C%20no%20text&width=160&height=160&seq=jj-ava-02&orientation=squarish",
    role: "治愈系常驻",
    content: "《春日便当店》完全是下饭神器，每集的料理镜头都拍得好温柔，看完就想自己动手做一顿。已加入我的深夜片单。",
    show: "春日便当店",
    likes: "1.1万",
    replies: "204",
    time: "25 分钟前",
  },
  {
    id: "d3",
    user: "星际信号员",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustrated%20avatar%20portrait%20of%20a%20young%20man%20wearing%20a%20beanie%2C%20clean%20bold%20shapes%2C%20solid%20warm%20pastel%20background%2C%20centered%20head%20and%20shoulders%2C%20modern%20editorial%20illustration%2C%20no%20text&width=160&height=160&seq=jj-ava-03&orientation=squarish",
    role: "科幻区版主",
    content: "整理了一份国产科幻专题，从早期短片到近年的工业级作品都收录了，想入坑的朋友直接照合集顺序看就行。",
    show: "专题合集",
    likes: "8673",
    replies: "152",
    time: "52 分钟前",
  },
  {
    id: "d4",
    user: "老片收藏夹",
    avatar:
      "https://readdy.ai/api/search-image?query=Minimal%20flat%20illustrated%20avatar%20portrait%20of%20an%20older%20woman%20with%20a%20hair%20bun%2C%20clean%20bold%20shapes%2C%20solid%20warm%20pastel%20background%2C%20centered%20head%20and%20shoulders%2C%20modern%20editorial%20illustration%2C%20no%20text&width=160&height=160&seq=jj-ava-04&orientation=squarish",
    role: "经典重映守望者",
    content: "黄金年代重映专题更新啦！画质修复得比想象中好，配乐一响起来直接泪目，年轻观众也值得看看。",
    show: "经典重映 · 黄金年代",
    likes: "6240",
    replies: "98",
    time: "1 小时前",
  },
];

export const stats = [
  { value: "38,600+", label: "收录影视资源" },
  { value: "1,240+", label: "高清影视专题" },
  { value: "12,000+", label: "每日更新条目" },
  { value: "260万", label: "影迷共同在看" },
];

export const footerGroups = [
  {
    title: "热门入口",
    links: ["今日更新", "电影专区", "电视剧专区", "综艺漫游", "动漫频道"],
  },
  {
    title: "发现内容",
    links: ["专题合集", "标签话题", "今日榜单", "剧迷热评", "经典重映"],
  },
  {
    title: "关于久久",
    links: ["站点介绍", "更新说明", "意见反馈", "内容合作", "免责声明"],
  },
];